<template>
  <wt-dropdown
    v-if="isRelevant"
    class="wt-story-aspect-ratio"
    type="normal right"
    :show-triangle="true"
    :items="aspectRatios"
    :cancelableSelection="true"
    :on-click-item="$_select"
    :current-item-id="currentItemId"
    :data-story-aspect-ratio="currentItemId"
  >
    <template v-slot:button="{ currentItem }">
      <span>
        <wt-aspect-ratio-tag
          :id="currentItem.id"
          :showRectangle="true"
          :showLabel="true"
        />
      </span>
      <i class="wticon wticon-chevron-down -chevron" />
    </template>
    <template v-slot:item="props">
      <span>{{ props.item.itemLabel }}</span>
    </template>
  </wt-dropdown>
</template>

<script>
import app from 'app';
import Vue from 'vue';
import wtAspectRatioTag from 'components/tags/wtAspectRatioTag.component.vue';
import wtDropdown from 'components/dropdowns/wtDropdown.component.vue';
import { mapGetters } from 'vuex';

export default Vue.extend({
  name: 'MastheadAspectRatio',
  components: {
    wtAspectRatioTag,
    wtDropdown,
  },

  data() {
    return {
      currentItemId: app.storyController?.story.get('aspectRatio'),
    };
  },

  computed: {
    ...mapGetters(['storyBrand']),

    isRelevant() {
      return this.aspectRatios.length > 0;
    },

    aspectRatios() {
      const rv = [];

      Object.keys(app.ASPECT_RATIOS).forEach((arKey) => {
        const found = this.$store.getters['storyBrand']?.themes.find(
          (theme) => theme.aspectRatio === arKey
        );
        if (found) {
          const ar = app.ASPECT_RATIOS[arKey];
          rv.push({
            id: arKey,
            label: ar.friendlyVal,
            itemLabel: `${ar.friendlyName} ${ar.friendlyVal}`,
          });
        }
      });

      return rv;
    },
  },

  methods: {
    $_select(id) {
      app.storyController?.story.aspectRatiosController
        .setNewAspectRatio(id)
        .then(() => {
          this.currentItemId = id;
        });
    },
  },
});
</script>

<style lang="scss" scoped>
@import 'style_guide/_sg_variables.scss';

.wt-story-aspect-ratio {
  width: 124px;
  user-select: none;

  .wt-aspect-ratio-tag /deep/ .-label {
    font-size: 14px;
    margin-left: 10px;
  }
}
</style>
